export default "__VITE_ASSET__d6105b4e__"